// @ts-check
/** @typedef {import('../types/api').ShopTile} ShopTile */

import api from '../utils/apiClient';
import { assertArray } from '../utils/apiGuards';

const shopTilesService = {
  /**
   * @returns {Promise<ShopTile[]>}
   */
  getAll: async () => {
    const data = await api.get('/api/admin/shop-tiles');
    assertArray(data, 'shopTilesService.getAll');
    return data;
  },

  /**
   * @param {Object} data
   * @returns {Promise<ShopTile>}
   */
  create: (data) => api.post('/api/admin/shop-tiles', data),

  /**
   * @param {string} id
   * @param {Object} data
   * @returns {Promise<ShopTile>}
   */
  update: (id, data) => api.patch(`/api/admin/shop-tiles/${id}`, data),

  /**
   * @param {string} id
   * @returns {Promise<void>}
   */
  delete: (id) => api.del(`/api/admin/shop-tiles/${id}`),

  /**
   * @param {Object[]} items
   * @returns {Promise<Object>}
   */
  reorder: (items) => api.patch('/api/admin/shop-tiles/reorder', items),
};

export default shopTilesService;
